import { render, staticRenderFns } from "./BudgetIntegrationIdcExpenses.vue?vue&type=template&id=47ff224d&scoped=true&"
import script from "./BudgetIntegrationIdcExpenses.vue?vue&type=script&lang=ts&"
export * from "./BudgetIntegrationIdcExpenses.vue?vue&type=script&lang=ts&"
import style0 from "./BudgetIntegrationIdcExpenses.vue?vue&type=style&index=0&id=47ff224d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ff224d",
  null
  
)

export default component.exports